export const isSelfGifting = (gift) => {
    return gift.self_gifted;
}

export const isVisa = (gift) => {
    return gift.merchant_slug === 'visa';
}